import { instance } from "../axios/axiosConfig";
import {
  CoreValue,
  CoreValuesParams,
  GenerateAIPersonaData,
  PersonaAPIResponseData,
  PersonasParams,
  PersonaUpdatePayload,
} from "../types/personasTypes.tsx";

const personasApi = {
  fetchPersonasData(params?: PersonasParams) {
    return instance.get<PersonaAPIResponseData[]>(`/api/personas/`, { params });
  },
  fetchPersonaById(id: string | number) {
    return instance.get<PersonaAPIResponseData>(`/api/personas/${id}/`);
  },
  createPersona(personaData: FormData) {
    return instance.post<PersonaAPIResponseData>(
      `/api/personas/`,
      personaData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
  },
  deletePersona(id: string | number) {
    return instance.delete<PersonaAPIResponseData>(`/api/personas/${id}/`);
  },
  updatePersona(
    id: string | number,
    dataToUpdate: FormData | Partial<PersonaUpdatePayload>,
  ) {
    const headers =
      dataToUpdate instanceof FormData
        ? { "Content-Type": "multipart/form-data" }
        : { "Content-Type": "application/json" };

    return instance.patch<PersonaAPIResponseData>(
      `/api/personas/${id}/`,
      dataToUpdate,
      { headers },
    );
  },
  generateAIPersona(data: GenerateAIPersonaData) {
    return instance.post<PersonaAPIResponseData[]>(
      `/api/personas/generate/`,
      data,
    );
  },
  fetchCoreValues(params?: CoreValuesParams) {
    return instance.get<CoreValue[]>(`/api/core-values/`, { params });
  },
};

export default personasApi;
